import { render, staticRenderFns } from "./carcouponshop.vue?vue&type=template&id=3b475648&"
import script from "./carcouponshop.vue?vue&type=script&lang=js&"
export * from "./carcouponshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports